import React from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import IconChevronDown from '@/assets/icon-chevron-down.svg?react';
import EnergySavingsStore from '@/store/EnergySavingsStore';
import { EPButton } from '@/components';
import { Container } from './styled';

type YearChangeProps = {
  energySavingsStore?: EnergySavingsStore;

  requestedYear?: number;
  setRequestedYear?: (requestedRear: number) => void;
  isReady?: boolean;

  yearOffsetLimit?: number;
  baselinePeriodData?: {
    baselineStart: string;
    baselineEnd: string;
  };
  isWidget?: boolean;
};

type YearChangePropsWithStore = YearChangeProps & {
  energySavingsStore: EnergySavingsStore;
};

type YearChangePropsWithFields = YearChangeProps & {
  requestedYear: number;
  setRequestedYear: (requestedRear: number) => void;
  isReady: boolean;
};

const YearPager = observer((props: YearChangePropsWithStore | YearChangePropsWithFields) => {
  const { t } = useTranslation();
  const internalProps = {
    ...props,
    requestedYear: props.energySavingsStore?.requestedYear ?? props.requestedYear,
    setRequestedYear: props.energySavingsStore?.setRequestedYear ?? props.setRequestedYear,
    isReady: props.energySavingsStore?.isReady ?? props.isReady,
  };

  const currentYear = internalProps.energySavingsStore?.requestedYear ?? internalProps.requestedYear;
  const isReady = () => (internalProps.isReady !== undefined ? internalProps.isReady : true);
  const isPreviousYearAvailable = () => {
    if (internalProps.yearOffsetLimit) {
      return currentYear > moment().year() - internalProps.yearOffsetLimit;
    } else {
      return currentYear > 2020;
    }
  };
  const isNextYearAvailable = () => {
    return currentYear < moment().year();
  };
  const onPreviousYearClick = () => {
    if (isReady() && isPreviousYearAvailable()) {
      internalProps.setRequestedYear(currentYear - 1);
    }
  };

  const onNextYearClick = () => {
    if (isReady() && isNextYearAvailable()) {
      internalProps.setRequestedYear(currentYear + 1);
    }
  };

  return (
    <Container $isWidget={internalProps.isWidget}>
      <div className="year-navigation">
        <EPButton
          onClick={onPreviousYearClick}
          type={'link'}
          className={!isPreviousYearAvailable() ? 'disabled' : 'enabled'}
        >
          <IconChevronDown className="chevron left" />
        </EPButton>
        <div className="year-container">
          <span className="year-number">{currentYear}</span>
        </div>
        <EPButton onClick={onNextYearClick} type={'link'} className={isNextYearAvailable() ? 'enabled' : 'disabled'}>
          <IconChevronDown className="chevron right" />
        </EPButton>
      </div>

      {internalProps.baselinePeriodData && (
        <div className="baseline-period-container">
          <span className="baseline-period-label"> {t('Baseline Period')} </span>
          <span className="baseline-period-number">
            {internalProps.baselinePeriodData.baselineStart} - {internalProps.baselinePeriodData.baselineEnd}
          </span>
        </div>
      )}
    </Container>
  );
});

export default YearPager;
